export default "__VITE_ASSET__B9OzwL23__"